import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack, MdModeEdit, MdAutorenew, MdLens } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { clientActions } from "./actions/clients.actions";

import { Spinner, Placeholder } from "../Shared";
import { routeConstants } from "../../_constants";

export class Client extends Component {
  componentDidMount() {
    this.getClient();
  }

  componentWillUnmount() {
    this.props.resetClient();
  }

  getClient = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getClient(match.params.id);
    }
  };

  render() {
    const { match, response, fetching, error } = this.props;
    const client = response && response.modelList[0];

    return (
      <div>
        <Row>
          <Col sm="6">
            <Link
              className="btn btn-outline btn-primary"
              to={routeConstants.CLIENTS.path}
            >
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                <div>
                  Client: {client && client.code}{" "}
                  <Button
                    onClick={this.getClient}
                    color="primary"
                    outline
                    disabled={fetching}
                  >
                    {fetching ? (
                      <Spinner />
                    ) : (
                      <div>
                        <MdAutorenew size={20} />
                      </div>
                    )}
                  </Button>
                </div>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            {error && (
              <Alert color="danger">
                <strong>Error:</strong> {error.message}
              </Alert>
            )}

            <dl className="row">
              {/* <dt className="col-sm-3">Client</dt>
              <dd className="col-sm-9">
                {client ? (
                  client.id
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd> */}

              <dt className="col-sm-3">Client Code</dt>
              <dd className="col-sm-9">
                {client ? (
                  client.code
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Client Description</dt>
              <dd className="col-sm-9">
                {client ? (
                  client.description
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Primary Domain</dt>
              <dd className="col-sm-9">
                {client ? (
                  client.primaryDomain
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Access Token</dt>
              <dd className="col-sm-9">
                {client ? (
                  client.accessToken
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Security Keys</dt>
              <dd className="col-sm-9">
                {client ? (
                  client.securityKeys
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Primary Domain</dt>
              <dd className="col-sm-9">
                {client ? (
                  client.primaryDomain
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Client Status</dt>
              <dd className="col-sm-9">
                {client ? (
                  client.enabled ? (
                    <span>
                      <MdLens className="text-success" /> Enabled
                    </span>
                  ) : (
                    <span>
                      <MdLens className="text-danger" /> Disabled
                    </span>
                  )
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Client is trusted</dt>
              <dd className="col-sm-9">
                {client ? (
                  client.isTrusted ? (
                    <span>
                      <MdLens className="text-success" /> Trusted
                    </span>
                  ) : (
                    <span>
                      <MdLens className="text-danger" /> Not trusted
                    </span>
                  )
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>
            </dl>
            <Link
              className="btn btn-primary"
              to={`${routeConstants.CLIENTS.path}/edit/${match.params.id}`}
            >
              <MdModeEdit /> Edit
            </Link>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, request, response, error } = state.viewClient;
  return {
    fetching,
    fetched,
    request,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getClient: bindActionCreators(clientActions.getClient, dispatch),
    resetClient: bindActionCreators(clientActions.resetClient, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Client);
